/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ArenaParticipant } from './ArenaParticipant';
import type { Case } from './Case';
export type ArenaRoom = {
    id?: string;
    /**
     * Short room identifier
     */
    shortId?: string;
    /**
     * Number of slots (2-4)
     */
    slots?: number;
    /**
     * Slots per team
     */
    slotsPerTeam?: number;
    /**
     * Array of case IDs used in this room
     */
    caseIds?: Array<string>;
    /**
     * Case objects (populated)
     */
    cases?: Array<Case>;
    /**
     * Entry fee per slot in cents
     */
    upfrontPayPerSlot?: number;
    /**
     * Whether room is sponsored
     */
    isSponsored?: boolean;
    /**
     * Whether room is private
     */
    isPrivate?: boolean;
    /**
     * Whether room uses tokens instead of balance
     */
    isTokenRoom?: boolean;
    /**
     * Room status: 0=Waiting, 1=Ready, 2=Rolling, 3=Finished, 4=Cancelled
     */
    status?: ArenaRoom.status;
    /**
     * Room participants
     */
    participants?: Array<ArenaParticipant>;
    /**
     * Room creator ID
     */
    creatorId?: string;
    createdAt?: string;
    updatedAt?: string;
};
export namespace ArenaRoom {
    /**
     * Room status: 0=Waiting, 1=Ready, 2=Rolling, 3=Finished, 4=Cancelled
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
    }
}

